var render = function render(){var _vm=this,_c=_vm._self._c;return _c('role-details-form',{staticClass:"mt-6 ml-6 pr-6"})
}
var staticRenderFns = []

export { render, staticRenderFns }